(() => {
  const overlay = document.getElementById('waSearchOverlay');
  if (!overlay) return;

  const input = document.getElementById('waSearchInput');
  const left = document.getElementById('waSearchLeft');
  const right = document.getElementById('waSearchRight');
  const cta = document.getElementById('waSearchCta');

  const headerInput = document.getElementById('waHeaderSearchInput');

  // ✅ Fallback suggestions (premium)
  const FALLBACK_SUGGESTIONS = [
    'Accueil',
  'Homme',
  'Femme',
  'Unisexe',
  'Cosmétiques',
  'Nouveautés Homme',
  'Nouveautés Femme',
  'Nouveautés Unisexe',
  'Marques Homme',
  'Marques Femme',
  'Marques Unisexe',
  'Vêtements Homme',
  'Vêtements Femme',
  'Vêtements Unisexe',
  'T-shirts Homme',
  'Chemises Homme',
  'Pantalons Homme',
  'Jeans Homme',
  'Maille Homme',
  'Sweats Homme',
  'Manteaux & Vestes Homme',
  'T-shirts Femme',
  'Chemises Femme',
  'Pantalons Femme',
  'Jeans Femme',
  'Maille Femme',
  'Sweats Femme',
  'Manteaux & Vestes Femme',
  'Cosmétiques Visage',
  'Types de soins – Visage',
  'Hydratation Skincare',
  'Anti-âge Skincare',
  'Anti-imperfection Skincare',
  'Best Sellers Cosmétiques',
  'Innovations Cosmétiques',
  'Tendances Cosmétiques',
  'Guide des tailles',
  'Aide & contact',
  'FAQ',
  'Commandes et livraison',
  'Retours et remboursements',
  'Paiements',
  'Conditions générales de vente',
  'Politique de confidentialité',
  'Mentions légales',
  'Plan du site',
  'À propos de nous',
  'Presse'
  ];

  const RECENT_KEY = 'wa_recent_searches_v1';
  const RECENT_MAX = 8;

  let abortCtrl = null;
  let t = null;
  let openedFromHeader = false;

  // Keyboard nav
  let activeIndex = -1;

  function lockScroll(lock) {
    document.documentElement.classList.toggle('wa-noScroll', lock);
    document.body.classList.toggle('wa-noScroll', lock);
  }

  function openOverlay() {
    overlay.classList.add('is-open');
    overlay.setAttribute('aria-hidden', 'false');
    lockScroll(true);
    setTimeout(() => input && input.focus(), 50);
    renderEmptyState();
  }

  function closeOverlay() {
    overlay.classList.remove('is-open');
    overlay.setAttribute('aria-hidden', 'true');
    lockScroll(false);

    if (input) input.value = '';
    activeIndex = -1;

    if (openedFromHeader && headerInput) {
      headerInput.value = '';
      openedFromHeader = false;
    }
  }

  function getRecents() {
    try { return JSON.parse(localStorage.getItem(RECENT_KEY) || '[]'); }
    catch { return []; }
  }

  function pushRecent(q) {
    const v = (q || '').trim();
    if (!v) return;
    let arr = getRecents().filter(x => x.toLowerCase() !== v.toLowerCase());
    arr.unshift(v);
    arr = arr.slice(0, RECENT_MAX);
    localStorage.setItem(RECENT_KEY, JSON.stringify(arr));
  }

  function removeRecent(q) {
    let arr = getRecents().filter(x => x !== q);
    localStorage.setItem(RECENT_KEY, JSON.stringify(arr));
    renderEmptyState();
  }

  function escapeHtml(str) {
    return String(str || '').replace(/[&<>"']/g, m =>
      ({ '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#039;' }[m])
    );
  }

  function escapeRegExp(str) {
    return String(str || '').replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  // ✅ Highlight safe: escape first, then wrap matches
  function highlightText(text, q) {
    const s = String(text || '');
    const query = String(q || '').trim();
    if (!query) return escapeHtml(s);

    const safe = escapeHtml(s);
    const re = new RegExp(`(${escapeRegExp(query)})`, 'ig');
    return safe.replace(re, '<mark class="wa-hl">$1</mark>');
  }

  // Price formatting: Shopify suggest.json can return cents or formatted strings
  function formatPrice(val) {
    if (val == null || val === '') return '';
    if (typeof val === 'string' && /[€$£]|[0-9]\s?[0-9]{2}$/.test(val)) return val;

    const n = Number(val);
    if (!Number.isFinite(n)) return String(val);

    const amount = n > 999 ? (n / 100) : n;
    try {
      return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(amount);
    } catch {
      return `${amount.toFixed(2)} €`;
    }
  }

  async function fetchTrending() {
    const collectionHandle = 'all';
    const sortBy = 'best-selling';
    const url = `/collections/${collectionHandle}?sort_by=${sortBy}&sections=wa-trending-products`;
    const res = await fetch(url, { credentials: 'same-origin' });
    const json = await res.json();
    return json['wa-trending-products'] || '';
  }

  function renderRecents() {
    const recents = getRecents();

    if (!recents.length) {
      return `
        <div class="wa-blockTitle">Recherches récentes</div>
        <div class="wa-list">
          <div class="wa-item__meta">Aucune recherche récente</div>
        </div>`;
    }

    const qNow = input?.value || '';

    const items = recents.map(q => `
      <div style="display:flex; align-items:center; justify-content:space-between; gap:10px;">
        <a class="wa-item" href="/search?q=${encodeURIComponent(q)}" data-wa-push-recent="${escapeHtml(q)}">
          <div class="wa-item__name">${highlightText(q, qNow)}</div>
        </a>
        <button type="button"
          aria-label="Supprimer"
          data-wa-recent-remove="${escapeHtml(q)}"
          style="border:0;background:transparent;cursor:pointer;font-size:18px;">
          ×
        </button>
      </div>
    `).join('');

    return `<div class="wa-blockTitle">Recherches récentes</div><div class="wa-list">${items}</div>`;
  }

  async function renderEmptyState() {
    activeIndex = -1;

    left.innerHTML = `<div class="wa-blockTitle">Tendances du moment</div><div class="wa-item__meta">Chargement…</div>`;
    right.innerHTML = renderRecents();

    try {
      const html = await fetchTrending();
      left.innerHTML = html || `<div class="wa-item__meta">Impossible de charger les tendances.</div>`;
    } catch {
      left.innerHTML = `<div class="wa-item__meta">Impossible de charger les tendances.</div>`;
    }
  }

  async function fetchPredictive(q) {
    const url =
      `/search/suggest.json?q=${encodeURIComponent(q)}` +
      `&resources[type]=query,product,collection,page,article` +
      `&resources[limit]=10` +
      `&resources[options][unavailable_products]=hide`;

    abortCtrl = new AbortController();
    const res = await fetch(url, { signal: abortCtrl.signal, credentials: 'same-origin' });
    return res.json();
  }

  // ✅ extraction robuste des suggestions "query"
  function extractQueries(data) {
    const r = data?.resources?.results || {};
    const candidates =
      r.queries ||
      r.query_suggestions ||
      r.suggestions ||
      data?.resources?.results?.queries ||
      data?.resources?.results?.query_suggestions ||
      [];

    if (!Array.isArray(candidates) || !candidates.length) return [];

    // IMPORTANT: on préfère .text (sans HTML) si dispo
    return candidates
      .map(s => (s?.text || s?.styled_text || s))
      .filter(Boolean)
      .map(x => String(x));
  }

  function buildFallbackQueries(q) {
    const needle = (q || '').trim().toLowerCase();
    if (!needle) return [];

    const merged = [...getRecents(), ...FALLBACK_SUGGESTIONS];

    const uniq = [];
    const seen = new Set();
    for (const item of merged) {
      const v = String(item).trim();
      if (!v) continue;
      const key = v.toLowerCase();
      if (seen.has(key)) continue;
      seen.add(key);

      if (key.includes(needle)) uniq.push(v);
    }
    return uniq.slice(0, 6);
  }

  // Petit helper pour titres + icônes (emoji)
  function blockTitle(icon, label) {
    return `<div class="wa-blockTitle"><span class="wa-blockIcon" aria-hidden="true">${icon}</span>${label}</div>`;
  }

  function renderPredictive(data) {
    activeIndex = -1;

    const r = data?.resources?.results || {};
    const products = r.products || [];
    const pages = r.pages || [];
    const collections = r.collections || [];

    const qNow = input?.value || '';

    // ✅ Shopify suggestions OR fallback
    let queries = extractQueries(data);
    if (!queries.length) queries = buildFallbackQueries(qNow);

    // ✅ LEFT: Pages (prio) -> Suggestions -> Collections
    const leftBlocks = [];

    if (pages.length) {
      leftBlocks.push(`
        ${blockTitle('📄', 'Pages')}
        <div class="wa-list">
          ${pages.slice(0, 6).map(p => `
            <a class="wa-item" href="${p.url}">
              <div class="wa-item__name">${highlightText(p.title, qNow)}</div>
            </a>
          `).join('')}
        </div>
      `);
    }

    if (queries.length) {
      leftBlocks.push(`
        <div style="${pages.length ? 'margin-top:14px;' : ''}">
          ${blockTitle('🔎', 'Suggestions')}
        </div>
        <div class="wa-list">
          ${queries.slice(0, 6).map(txt => {
            const url = `/search?q=${encodeURIComponent(txt)}`;
            return `<a class="wa-item" href="${url}" data-wa-push-recent="${escapeHtml(txt)}">
                      <div class="wa-item__name">${highlightText(txt, qNow)}</div>
                    </a>`;
          }).join('')}
        </div>
      `);
    }

    if (collections.length) {
      leftBlocks.push(`
        <div style="margin-top:14px;">
          ${blockTitle('🗂', 'Collections')}
        </div>
        <div class="wa-list">
          ${collections.slice(0, 6).map(c => `
            <a class="wa-item" href="${c.url}">
              <div class="wa-item__name">${highlightText(c.title, qNow)}</div>
            </a>
          `).join('')}
        </div>
      `);
    }

    left.innerHTML = leftBlocks.join('') || `<div class="wa-item__meta">Aucune suggestion.</div>`;

    // ✅ RIGHT: Products
    if (!products.length) {
      right.innerHTML = `<div class="wa-blockTitle">Produits</div><div class="wa-item__meta">Aucun produit trouvé.</div>`;
      return;
    }

    const prodHtml = products.slice(0, 10).map(p => {
      const titlePlain = String(p.title || '');
      const vendor = p.vendor ? escapeHtml(p.vendor) : '';
      const img = p.image ? `<img src="${p.image}" alt="${escapeHtml(titlePlain)}" loading="lazy">` : '';

      const priceTxt =
        p.price ? formatPrice(p.price) :
        (p.price_min ? formatPrice(p.price_min) : '');

      return `
        <a class="wa-item" href="${p.url}" data-wa-push-recent="${escapeHtml(titlePlain)}">
          <div class="wa-thumb">${img}</div>
          <div>
            <div class="wa-item__name">${highlightText(titlePlain, qNow)}</div>
            ${vendor ? `<div class="wa-item__meta">${vendor}</div>` : ''}
            ${priceTxt ? `<div class="wa-item__meta">${escapeHtml(priceTxt)}</div>` : ''}
          </div>
        </a>
      `;
    }).join('');

    right.innerHTML = `<div class="wa-blockTitle">Produits</div><div class="wa-list">${prodHtml}</div>`;
  }

  function onInput() {
    const q = (input?.value || '').trim();
    if (cta) cta.href = `/search?q=${encodeURIComponent(q)}`;

    if (!q) {
      renderEmptyState();
      return;
    }

    if (abortCtrl) abortCtrl.abort();

    clearTimeout(t);
    t = setTimeout(async () => {
      try {
        const data = await fetchPredictive(q);
        renderPredictive(data);
      } catch (e) {
        if (e.name !== 'AbortError') {
          left.innerHTML = `<div class="wa-item__meta">Erreur de recherche.</div>`;
          right.innerHTML = '';
        }
      }
    }, 180);
  }

  /* ===== Keyboard navigation ===== */
  function getNavigableItems() {
    // On prend les vrais liens de résultats
    return Array.from(overlay.querySelectorAll('.wa-list a.wa-item'));
  }

  function setActiveItem(index) {
    const items = getNavigableItems();
    items.forEach(el => el.classList.remove('is-active'));

    if (index < 0 || index >= items.length) {
      activeIndex = -1;
      return;
    }

    activeIndex = index;
    const el = items[activeIndex];
    el.classList.add('is-active');

    // Scroll doux dans le conteneur
    try { el.scrollIntoView({ block: 'nearest' }); } catch (_) {}
  }

  document.addEventListener('keydown', (e) => {
    if (!overlay.classList.contains('is-open')) return;

    // Ne pas intercepter si l’utilisateur est en train de composer (IME)
    if (e.isComposing) return;

    const items = getNavigableItems();
    if (!items.length) return;

    if (e.key === 'ArrowDown') {
      e.preventDefault();
      setActiveItem(activeIndex + 1);
      return;
    }

    if (e.key === 'ArrowUp') {
      e.preventDefault();
      setActiveItem(activeIndex - 1);
      return;
    }

    if (e.key === 'Enter') {
      if (activeIndex >= 0 && items[activeIndex]) {
        e.preventDefault();
        items[activeIndex].click();
      }
    }
  });

  /* Close */
  overlay.addEventListener('click', e => {
    if (e.target.matches('[data-wa-close]')) closeOverlay();
  });

  document.addEventListener('keydown', e => {
    if (e.key === 'Escape' && overlay.classList.contains('is-open')) closeOverlay();
  });

  /* Recent remove */
  overlay.addEventListener('click', e => {
    const btn = e.target.closest('[data-wa-recent-remove]');
    if (!btn) return;
    removeRecent(btn.getAttribute('data-wa-recent-remove'));
  });

  /* Push recent when clicking any element marked */
  overlay.addEventListener('click', e => {
    const a = e.target.closest('[data-wa-push-recent]');
    if (!a) return;
    pushRecent(a.getAttribute('data-wa-push-recent'));
  });

  /* Submit behavior */
  input.addEventListener('keydown', e => {
    if (e.key === 'Enter') {
      const q = input.value.trim();
      pushRecent(q);
      window.location.href = `/search?q=${encodeURIComponent(q)}`;
    }
  });

  if (cta) cta.addEventListener('click', () => pushRecent(input.value));
  input.addEventListener('input', onInput);

  /* ===== AUTO OPEN WHEN TYPING IN HEADER ===== */
  if (headerInput) {
    const openFromHeader = () => {
      if (!overlay.classList.contains('is-open')) {
        openedFromHeader = true;
        openOverlay();
      }
      input.value = headerInput.value || '';
      input.dispatchEvent(new Event('input', { bubbles: true }));
    };

    headerInput.addEventListener('keydown', e => {
      const isChar = e.key.length === 1 && !e.ctrlKey && !e.metaKey && !e.altKey;
      if (isChar) setTimeout(openFromHeader, 0);
    });

    headerInput.addEventListener('paste', () => setTimeout(openFromHeader, 0));
  }

  /* ===== OPEN OVERLAY FROM ANY ICON (data-wa-open-search) ===== */
  document.addEventListener('click', (e) => {
    const el = e.target.closest('[data-wa-open-search]');
    if (!el) return;
    e.preventDefault();
    openedFromHeader = false;
    openOverlay();
  }, { capture: true });

  window.WAOpenSearch = openOverlay;
})();